import { DynamicProfileHubBase } from '../DynamicProfileHubBase';
import { ProfileStoreType } from '../DynamicProfileEnums';
import { DynamicTerraceProfileStore } from './DynamicTerraceProfileStore';
import { DynamicTerraceMapStore } from './DynamicTerraceMapStore';
import { DynamicTerraceTableStore } from './DynamicTerraceTableStore';

class DynamicTerraceHub extends DynamicProfileHubBase {
  protected _profileStore: DynamicTerraceProfileStore | undefined;
  protected _mapStore: DynamicTerraceMapStore | undefined;
  protected _tableStore: DynamicTerraceTableStore | undefined;

  public createStore(storeType: ProfileStoreType, option: any = void 0) {
    switch (storeType) {
      case ProfileStoreType.MAP:
        this._mapStore = new DynamicTerraceMapStore(this);
        this.MapStore!.MapView = option?.mapView;
        this.disposer.Track(this._mapStore);
        break;

      case ProfileStoreType.PROFILE:
        this._profileStore = new DynamicTerraceProfileStore(this);
        this.disposer.Track(this._profileStore);
        break;

      case ProfileStoreType.TABLE:
        this._tableStore = new DynamicTerraceTableStore(this);
        this.disposer.Track(this._tableStore);
        break;

      default:
        break;
    }
  }

  private _setStore;
  set setStore(setStore) {
    this._setStore = setStore;
  }
  get setStore() {
    return this._setStore;
  }

  private _terraceStore;
  public get terraceStore() {
    return this._terraceStore;
  }
  public set terraceStore(value) {
    this._terraceStore = value;
  }
}

export { DynamicTerraceHub };
